import React from "react";
import { Phone } from "lucide-react";

const StickyCallBar = ({ show = true }) => {
  if (!show) return null;

  const linkClass =
    "flex-1 flex items-center justify-center gap-2 font-semibold text-base rounded-lg min-h-12 transition-colors";

  return (
    <div className="bg-red-700 border-t border-red-800 shadow-sm pb-[env(safe-area-inset-bottom)]">
      <div className="max-w-lg mx-auto px-3 py-2 flex items-center gap-2 min-h-[var(--footer-height)]">
        <a href="tel:112" className={`${linkClass} bg-white text-red-800 hover:bg-red-50`}>
          <Phone size={18} aria-hidden />
          <span>112</span>
        </a>
        <a href="tel:108" className={`${linkClass} bg-red-800 text-white hover:bg-red-900 border border-red-900`}>
          <Phone size={18} aria-hidden />
          <span>108</span>
        </a>
        <a href="tel:100" className={`${linkClass} bg-red-800/80 text-white hover:bg-red-900 border border-red-900/50`}>
          <Phone size={18} aria-hidden />
          <span>100</span>
        </a>
      </div>
    </div>
  );
};

export default StickyCallBar;
